import { render, staticRenderFns } from "./WalletDetail.vue?vue&type=template&id=b1cd2bc6&scoped=true"
import script from "./WalletDetail.vue?vue&type=script&lang=js"
export * from "./WalletDetail.vue?vue&type=script&lang=js"
import style0 from "./WalletDetail.vue?vue&type=style&index=0&id=b1cd2bc6&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1cd2bc6",
  null
  
)

export default component.exports